import { Box, Switch, Typography } from "@mui/material";
import {
  IncidentDateFieldSwitchProps,
  incidentFilterSelectedColour,
} from "../types";
import { incidentTableStyles } from "./styles";

export function IncidentDateFieldSwitch({
  value,
  onChange,
}: IncidentDateFieldSwitchProps) {
  const isDetectionTimeSelected = value === "incidentSpecificTime";

  return (
    <Box sx={incidentTableStyles.dateFieldSwitchContainerSx}>
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: !isDetectionTimeSelected ? 700 : 400,
          color: !isDetectionTimeSelected
            ? incidentFilterSelectedColour
            : "inherit",
        }}
      >
        Scanned At
      </Typography>

      <Switch
        checked={isDetectionTimeSelected}
        onChange={(_, checked) =>
          onChange(checked ? "incidentSpecificTime" : "scannedAt")
        }
        sx={{
          "& .MuiSwitch-switchBase": {
            color: incidentFilterSelectedColour,
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: incidentFilterSelectedColour,
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: incidentFilterSelectedColour,
          },
        }}
      />

      <Typography
        sx={{
          fontSize: 13,
          fontWeight: isDetectionTimeSelected ? 700 : 400,
          color: isDetectionTimeSelected
            ? incidentFilterSelectedColour
            : "inherit",
        }}
      >
        Detection Time
      </Typography>
    </Box>
  );
}
